import { useState, useRef, useEffect } from "react";

// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import shareIcon from "assets/svg/ShareIcon.svg";
import ArrowUpIcon from "assets/svg/RightRedIcon.svg";
import coverPlaceHolder from "assets/img/news1.jpg";
import facebookIcon from "assets/svg/FacebookGrey.svg";
import linkedInIcon from "assets/svg/LinkedInGrey.svg";
import DsuIcon from "assets/img/Logo-DSU@2x.png";
import calendarIcon from "assets/svg/data.svg";
import locationIcon from "assets/svg/locationGrey.svg";
import PhoneIcon from "assets/svg/phoneIconGrey.svg";
import mailIcon from "assets/svg/mail.svg";
import webSiteIcon from "assets/svg/web.svg";

// STYLES
import {
  NewsAndPartnersDetailsContainer,
  HeaderImageWrapper,
  HeaderImage,
  Body,
  FirstColumn,
  SecondColumn,
  ThirdColumn,
  BackToWrapper,
  BackToImage,
  BackToButton,
  TitleWrapper,
  ContentCard,
  SocialMediaCard,
  SocialMediaIcons,
  SocialMediaIcon,
  OtherGuidesCard,
  ImgStyled,
  OtherChapters,
  InsideFirstColumn,
  InsideThirdColumn,
  BackOnTopWrapper,
  BackOnTopImg,
  LeftCard,
  OtherCampaignsContent,
  CopyToClipboardWrapper,
  SkeletonWrapperOtherChapter,
  CopyToClipboardTooltip,
  SkeletonWrapperChapter,
  ScrollTargetWrapper,
  CenterCardTitle,
  ButtonWrapper,
  PartnerWrapper,
  ImgPartner,
  TitleLeftCard,
  ContentLeftCard,
  SectionsLeftCard,
  DetailsSection,
  ImgLeftSection,
  DetailsOtherEventsWrapper,
  RedCircle,
  CarouselWrapper,
  DetailsSectionLink,
} from "./DetailsEventStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { LinkedinShareButton, FacebookShareButton } from "react-share";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

// MISC

import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { BORDER_RADIUS, COLORS, DEVICE_TYPE } from "constants/variables";
import { appRoutes } from "config/AppRoutesConfig";
import { carouselCards } from "constants/mocks/Officials";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import formatDate from "utils/formatDate";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import MarkdownText from "components/Atoms/MarkdownText/MarkdownText";
import OfficialsCarousel from "components/OfficialsCarousel/OfficialsCarousel";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import newsAndMediaService from "services/newsAndMediaService";
import { EventProps } from "./DetailsEventModel";
import { uploadBaseUrl } from "services/base";
import StrapiTreeText from "components/Atoms/StrapiTreeText/StrapiTreeText";
import {
  LeftCardChapter,
  RedCircleWrapper,
} from "view/ProjectDetails/ProjectDetailsStyled";

const OfficialAnnouncementsDetails = () => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: DEVICE_TYPE.tablet });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { id } = useParams<{ id: string }>();

  // STATE CONSTANTS

  // STATE CONSTANTS

  const contentRefs = useRef([]);
  const [copied, setCopied] = useState(false);
  const [event, setEvent] = useState<EventProps>();
  const [anotherEvents, setAnotherEvents] = useState<any[]>();
  const headerImageWrapperRef = useRef(null);
  const skeletonCount = 3;

  // EVENT HANDLERS

  useEffect(() => {
    // setLoading(true);
    newsAndMediaService
      .getEventById(id)
      .then((response) => {
        // console.log(response?.data);

        setEvent(response?.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
    newsAndMediaService
      .getLastEvents()
      .then((response) => {
        // console.log(response?.data);
        setAnotherEvents(response?.data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, [id]);

  const scrollToTop = () => {
    if (headerImageWrapperRef.current) {
      headerImageWrapperRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => console.error("Failed to copy URL: ", err));
  };

  return (
    <NewsAndPartnersDetailsContainer>
      <HeaderImageWrapper ref={headerImageWrapperRef}>
        <HeaderImage
          src={
            event?.attributes?.photo?.data?.attributes?.url?.trim()
              ? `${uploadBaseUrl}${event?.attributes?.photo?.data?.attributes?.url}`
              : CoverPlaceholder
          }
          alt={"coverGuideImage"}
        />
      </HeaderImageWrapper>
      <Body>
        <FirstColumn>
          <InsideFirstColumn>
            <BackToWrapper
              onClick={() => navigate(-1)}
              biggerCursor={biggerCursor}
            >
              <BackToImage src={LeftArrow} alt="backIcon" />
              <BackToButton biggerCursor={biggerCursor}>
                <CustomText
                  text={t("view.detailsEvents.events")}
                  type={TextType.H5boldspaced}
                  color={COLORS.RaisinBlack}
                />
              </BackToButton>
            </BackToWrapper>
            <TitleWrapper>
              <CustomText text={event?.attributes?.title} type={TextType.H3} />
            </TitleWrapper>

            <PartnerWrapper>
              <ImgPartner
                src={
                  event?.attributes?.partener_logo?.data?.attributes?.url?.trim()
                    ? `${uploadBaseUrl}${event?.attributes?.partener_logo?.data?.attributes?.url}`
                    : CoverPlaceholder
                }
              />
              <CustomText
                text={event?.attributes?.partener}
                type={TextType.H4}
                color={COLORS.MetalicSilver}
              />
            </PartnerWrapper>

            <LeftCard>
              <TitleLeftCard>
                <CustomText
                  text={t("view.detailsEvents.dateEvent")}
                  type={TextType.H3}
                />
              </TitleLeftCard>
              <ContentLeftCard>
                <SectionsLeftCard>
                  <CustomText
                    text={t("view.detailsEvents.dateAndHour")}
                    type={TextType.H4}
                    color={COLORS.MetalicSilver}
                  />
                  <DetailsSection>
                    <ImgLeftSection src={calendarIcon} />
                    <CustomText
                      text={
                        event?.attributes?.start_date
                          ? formatDate(
                              event?.attributes?.start_date,
                              event?.attributes?.end_date,
                              "ro"
                            )
                          : t("app.noSchedule")
                      }
                      type={TextType.P1}
                    />
                  </DetailsSection>
                </SectionsLeftCard>
                <SectionsLeftCard>
                  <CustomText
                    text={t("view.detailsEvents.location")}
                    type={TextType.H4}
                    color={COLORS.MetalicSilver}
                  />
                  <DetailsSection>
                    <ImgLeftSection src={locationIcon} />
                    <CustomText
                      text={`${event?.attributes?.address || ""} ${event?.attributes?.city || ""}`}
                      type={TextType.P1}
                    />
                  </DetailsSection>
                </SectionsLeftCard>
                <SectionsLeftCard>
                  <CustomText
                    text={t("view.detailsEvents.contact")}
                    type={TextType.H4}
                    color={COLORS.MetalicSilver}
                  />
                  {event?.attributes?.phone && <DetailsSectionLink href={`tel:${event?.attributes?.phone}`}>
                    <ImgLeftSection src={PhoneIcon} />
                    <CustomText
                      text={event?.attributes?.phone}
                      type={TextType.P1}
                      color={COLORS.RaisinBlack}
                    />
                  </DetailsSectionLink>}
                  <DetailsSectionLink
                    href={`mailto:${event?.attributes?.email}`}
                  >
                    <ImgLeftSection src={mailIcon} />
                    <CustomText
                      text={event?.attributes?.email}
                      type={TextType.P1}
                      color={COLORS.RaisinBlack}
                    />
                  </DetailsSectionLink>
                  <DetailsSectionLink
                    href={event?.attributes?.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ImgLeftSection src={webSiteIcon} />
                    <CustomText
                      text={event?.attributes?.website}
                      type={TextType.P1}
                      color={COLORS.RaisinBlack}
                    />
                  </DetailsSectionLink>
                </SectionsLeftCard>
              </ContentLeftCard>
            </LeftCard>
          </InsideFirstColumn>
        </FirstColumn>
        <SecondColumn>
          {event?.attributes.content.length > 0 ? (
            <ScrollTargetWrapper
              ref={contentRefs.current[0]}
              // key={index}
              id={event?.attributes.title}
            >
              <ContentCard tabIndex={0}>
                <CenterCardTitle>
                  <CustomText
                    text={event?.attributes?.title}
                    type={TextType.H3}
                  />
                </CenterCardTitle>
                <StrapiTreeText text={event?.attributes?.content} />
              </ContentCard>
            </ScrollTargetWrapper>
          ) : (
            <ContentCard tabIndex={0}>
              <Skeleton
                width={"100%"}
                count={105}
                baseColor={COLORS.Background}
                highlightColor={COLORS.Cultured}
              />
            </ContentCard>
          )}
        </SecondColumn>
        <ThirdColumn>
          <InsideThirdColumn>
            <SocialMediaCard>
              <CustomText
                text={"SHARE"}
                type={TextType.H5}
                color={COLORS.Yellow}
              />
              <SocialMediaIcons>
                <FacebookShareButton url={window.location.href}>
                  <SocialMediaIcon
                    src={facebookIcon}
                    alt="facebookIcon"
                    biggerCursor={biggerCursor}
                  />
                </FacebookShareButton>
                <LinkedinShareButton url={window.location.href}>
                  <SocialMediaIcon
                    src={linkedInIcon}
                    alt="linkedInIcon"
                    biggerCursor={biggerCursor}
                  />
                </LinkedinShareButton>
                <CopyToClipboardWrapper onClick={handleCopyToClipboard}>
                  <SocialMediaIcon
                    src={shareIcon}
                    alt="shareIcon"
                    biggerCursor={biggerCursor}
                  />
                  {copied && (
                    <CopyToClipboardTooltip>
                      <CustomText
                        text={t(
                          "view.newsAndMedia.officialAnnouncementsDetails.copyClipboard"
                        )}
                        type={TextType.P2}
                        color={COLORS.RaisinBlack}
                      />
                    </CopyToClipboardTooltip>
                  )}
                </CopyToClipboardWrapper>
              </SocialMediaIcons>
            </SocialMediaCard>
            <OtherGuidesCard>
              <CustomText
                text={t("view.detailsEvents.otherEvents")}
                type={TextType.H3}
              />
              {anotherEvents?.length > 0 ? (
                anotherEvents
                  .filter((event: any) => event?.id !== Number(id)) // Exclude current event if needed
                  .slice(0, 3) // Render only 3 events
                  .map((event: any, index: number) => (
                    <OtherChapters key={index} biggerCursor={biggerCursor}>
                      <ImgStyled
                        src={
                          event?.attributes?.photo?.data?.attributes?.url?.trim()
                            ? `${uploadBaseUrl}${event?.attributes?.photo?.data?.attributes?.url}`
                            : CoverPlaceholder
                        }
                        alt={"imageOthercampaigns"}
                        onClick={() =>
                          navigate(appRoutes.eventDetails + event?.id)
                        }
                      />
                      <DetailsOtherEventsWrapper>
                        <OtherCampaignsContent
                          onClick={() =>
                            navigate(appRoutes.eventDetails + event?.id)
                          }
                        >
                          <CustomText
                            text={event?.attributes?.title}
                            type={TextType.H4officials}
                          />
                        </OtherCampaignsContent>
                        <CustomText
                          text={
                            event?.attributes?.start_date
                              ? formatDate(
                                  event?.attributes?.start_date,
                                  event?.attributes?.end_date,
                                  "ro"
                                )
                              : t("app.noSchedule")
                          }
                          type={TextType.P2}
                          color={COLORS.MetalicSilver}
                        />
                        <CustomText
                          text={
                            event?.attributes?.address &&
                            event?.attributes?.city
                              ? `${event?.attributes?.address}, ${event?.attributes?.city}`
                              : t("app.noAdress")
                          }
                          type={TextType.P2}
                          color={COLORS.MetalicSilver}
                        />
                      </DetailsOtherEventsWrapper>
                    </OtherChapters>
                  ))
              ) : (
                <>
                  {[...Array(skeletonCount)].map((_, index) => (
                    <SkeletonWrapperOtherChapter key={index}>
                      <Skeleton
                        width={"80px"}
                        height={"80px"}
                        borderRadius={BORDER_RADIUS.radius16}
                        baseColor={COLORS.Background}
                        highlightColor={COLORS.Cultured}
                      />
                      <SkeletonWrapperChapter>
                        <Skeleton
                          count={1}
                          baseColor={COLORS.Background}
                          highlightColor={COLORS.Cultured}
                        />
                      </SkeletonWrapperChapter>
                    </SkeletonWrapperOtherChapter>
                  ))}
                </>
              )}
            </OtherGuidesCard>
            <OtherGuidesCard>
              <CustomText
                text={t("view.detailsEvents.access")}
                type={TextType.H3}
              />
              {/* <CustomText
                text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit"}
                type={TextType.P2}
              /> */}
              <ButtonWrapper>
                <ButtonAtom
                  type={ButtonType.RedButton}
                  text={t("view.detailsEvents.mapEvents")}
                  hasArrow={true}
                  onClick={() => navigate(`${appRoutes.map}/evenimente-11`)}
                />
              </ButtonWrapper>
            </OtherGuidesCard>
          </InsideThirdColumn>
        </ThirdColumn>
      </Body>
      <CarouselWrapper>
        <OfficialsCarousel data={carouselCards} />
      </CarouselWrapper>
      {isMobile && (
        <BackOnTopWrapper onClick={scrollToTop}>
          <BackOnTopImg src={ArrowUpIcon} alt="ArrowUpIcon" />
        </BackOnTopWrapper>
      )}
    </NewsAndPartnersDetailsContainer>
  );
};

export default OfficialAnnouncementsDetails;
